// extracted by mini-css-extract-plugin
export default {"HrDashBoard":"HrDashBoard_HrDashBoard__dsWOD"};